import { UserId, UserIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "./system"
import { UserDenormalizedWithoutLook } from "./user"

export const SpaceHiddenViewerCreatedBy = z.object({
  kind: z.enum(["owner", "moderator"]),
  user_id: UserIdSchema,
})

export type SpaceHiddenViewerCreatedBy = z.infer<typeof SpaceHiddenViewerCreatedBy>

export const SpaceHiddenViewerDocumentBody = z.object({
  created_at: CreatedAt,
  updated_at: UpdatedAt,
  created_by: SpaceHiddenViewerCreatedBy.optional(),
})

export type SpaceHiddenViewerDocumentBody = z.infer<typeof SpaceHiddenViewerDocumentBody>

export const SpaceHiddenViewerDocument = z.intersection(
  SpaceHiddenViewerDocumentBody,
  z.object({
    id: UserIdSchema,
    user: UserDenormalizedWithoutLook,
  })
)

export type SpaceHiddenViewerDocument = z.infer<typeof SpaceHiddenViewerDocument>

export class SpaceHiddenViewers {

  public static readonly LIMIT_OWN = 3000

}

export class SpaceHiddenViewerDocuments {

  static toDocumentData(doc: SpaceHiddenViewerDocument): object {
    return {
      ...doc,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): SpaceHiddenViewerDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: UserId(doc.id),
      user: data["user"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
      created_by: data["created_by"],
    }
  }
}
